import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

interface AIChatMessagesState {
    messages: any[];
}

const initialState: AIChatMessagesState = {
    messages: [],
};

const aiChatMessagesSlice = createSlice({
    name: 'aiChatMessages',
    initialState,
    reducers: {
        setMessages(state, action: PayloadAction<any[]>) {
            state.messages = action.payload;
        },
        addMessage(state, action: PayloadAction<any>) {
            state.messages.push(action.payload);
        },
        updateLastMessage(state, action: PayloadAction<Partial<any>>) {
            const lastIndex = state.messages.length - 1;
            if (lastIndex >= 0) {
                state.messages[lastIndex] = {
                    ...state.messages[lastIndex],
                    ...action.payload,
                };
            }
        },
        clearMessages(state) {
            state.messages = [];
        },
    },
});

export const selectAiMessages = (state: RootState) =>
    state.aiChatMessages.messages;

export const { setMessages, addMessage, updateLastMessage, clearMessages } =
    aiChatMessagesSlice.actions;

export const aiChatMessagesReducer = aiChatMessagesSlice.reducer;
